import { render, staticRenderFns } from "./betcancel.vue?vue&type=template&id=f5ba1e08&"
import script from "./betcancel.vue?vue&type=script&lang=js&"
export * from "./betcancel.vue?vue&type=script&lang=js&"
import style0 from "./betcancel.vue?vue&type=style&index=0&id=f5ba1e08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports